import styled from '@emotion/styled'
import { themeColor, stylesIf } from 'utils/styles'
import { HoverableInfoIcon, Divider } from 'components/patterns'
import { Row } from 'antd'
import CollectionCard from './Card'

export const CollectionSearch = styled.div`
  width: 100%;
`

export const NotFoundMessage = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  color: ${themeColor('greyPrimary')};
  text-align: center;
  padding: 15px;
`

// Bug 479123 Issue 20: Reduce space between text and tooltip icon
export const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
`

export const TooltipLabel = styled.span`
  font-size: 12px;
  color: ${themeColor('greyPrimary')};
  margin-top: -8px;
`

export const StyledHovarableInfoIcon = styled(HoverableInfoIcon)`
  margin-bottom: 15px;
  margin-left: 5px;
`

export const StyledSearchSortLabel = styled.div`
  margin-right: 5px;
`

export const SortContainer = styled(Row)`
  display: flex;
  align-items: center;
`

export const SearchTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 395px;
`

export const SearchInputContainer = styled.div`
  width: 395px;
`

export const SearchContainer = styled.div((props) => {
  const { isLoading } = props
  return `
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    padding: 0 0;
    margin: 25px 16px;
    ${stylesIf(
      isLoading,
      `
      opacity: 0.7;
      pointer-events: none;
    `
    )}
  `
})

export const CollectionsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  gap: 16px;
  padding: 0 18px 16px;
  width: 100%;
`

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledCol = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
`

export const StyledCollectionCard = styled(CollectionCard)`
  width: calc(50% - 16px);
`

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
`

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`

// Override Ant Design's default margin (0 8px) and short height (0.9em) on vertical dividers
// so the flex gap alone controls spacing and the bar spans the full 32px row height (per Figma)
export const StyledVerticalDivider = styled(Divider)`
  &.ant-divider-vertical {
    margin: 0;
    height: 32px;
    top: 0;
    border-color: ${themeColor('grey')};
  }
`
